import React from 'react';
import './formField.css'

const FormField = ({isLoading, isValid, labelBoolean, labelName, name, type, value, handleChange, handleBlur, inputType, textareaType, readOnly, maxLength, errors}) => {

  return (
    <>
      <div className='reg-input-group'>
          {inputType ? (
            <>
              <input
                  name={name}
                  type={type}
                  value={value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  autoComplete='off'
                  className='reg-input'
                  readOnly={readOnly}
                  maxLength={maxLength}
              />
            </>
          ) : textareaType ? (
              <textarea required className='reg-textarea-select-group' name={name} value={value} onChange={handleChange} onBlur={handleBlur} maxLength={maxLength}></textarea>
          ) : null}

          {!labelBoolean && (
            <label htmlFor={name} className="reg-input-label">
              {labelName}
            </label>
          )}
        <div className={`spinner ${isLoading ? 'loading' : ''}`}></div>
      </div>
      <div className={`validation ${!isValid ? 'invalid' : ''}`}>
        {errors}
      </div>
    </>
  )
}

export default FormField